module.exports = __webpack_public_path__ + "static/media/savadov-r.cc98af63.png";